export enum SubmissionStatusIdEnum {
  Pending = 1,
  Submitted = 2,
  InReview = 3,
  Completed = 4,
  Cancelled = 5
}
